import React, { Component, Fragment } from "react";
import { Map, TileLayer, Marker, withLeaflet } from "react-leaflet";
import { ReactLeafletSearch } from "react-leaflet-search";
import { cloneDeep } from "lodash";
import { Button, Col, Form, Input, Modal, Row, Select } from "antd";
import {
  CalendarOutlined,
  EnvironmentOutlined,
  HomeOutlined,
  MinusOutlined,
  MobileOutlined,
  PhoneOutlined,
  PlusOutlined,
  UserOutlined,
} from "@ant-design/icons";
import DatePicker from "react-modern-calendar-datepicker";
import moment from "moment-jalaali";
import { Constants } from "../scripts/settings";
import Resources from "../scripts/resources";
import Rules from "../scripts/rules";
import API from "../scripts/api";
const { Option } = Select;

const ReactLeafletSearchComponent = withLeaflet(ReactLeafletSearch);

class ModalMap extends Component {
  constructor() {
    super();

    this.state = {
      lat: Constants.defaultLat,
      lng: Constants.defaultLng,
    };
  }

  handleClick = (e = {}) => {
    this.setState({ lat: e.latlng.lat, lng: e.latlng.lng });
  };

  handleDidMount = (address) => {
    this.setState({
      lat: address.lat || Constants.defaultLat,
      lng: address.lng || Constants.defaultLng,
    });
  };

  render() {
    const { onCancel, onOk, visible } = this.props;
    const { lat, lng } = this.state;

    return (
      <Modal
        title={Resources.chooseLocation}
        visible={visible}
        onOk={() => onOk(lat, lng)}
        onCancel={onCancel}
        okText={Resources.confirm}
        cancelText={Resources.cancel}
        width={748}
      >
        <Map
          center={{ lat: lat, lng: lng }}
          length={4}
          onClick={this.handleClick}
          zoom={Constants.defaultZoom}
          style={{ height: 412, width: "100%" }}
        >
          <TileLayer
            attribution='&copy; <a href="http://osm.org/copyright">OpenStreetMap</a> contributors'
            url="http://{s}.tile.osm.org/{z}/{x}/{y}.png"
          />
          <ReactLeafletSearchComponent
            inputPlaceholder={Resources.search}
            position="topleft"
            provider="OpenStreetMap"
            providerOptions={{ region: "ir" }}
            showMarker={false}
            showPopup={false}
            closeResultsOnClick={true}
            zoom={Constants.defaultZoom}
          />
          <Marker position={{ lat: lat, lng: lng }} />
        </Map>
      </Modal>
    );
  }
}

class UserForm extends Component {
  constructor() {
    super();

    this.state = {
      title: "",
      addresses: [{ id: 0 }],
      phones: [],
      selectedAddress: 0,
      visibleMap: false,
      cities: [],
      neighborhoods: []

    };

    this.formRef = React.createRef();
    this.mapRef = React.createRef();
  }

  showMap = (address) => {
    this.setState({ visibleMap: true, selectedAddress: address });

    setTimeout(() => {
      this.mapRef.current.handleDidMount(address);
    }, 0);
  };

  hideMap = () => {
    this.setState({ visibleMap: false });
  };

  handleChangeDate = (date, obj) => {
    const state = {};
    state[obj] = date;
    this.formRef.current.setFieldsValue(state);
  };

  handleLatLng = (lat, lng) => {
    const { addresses, selectedAddress } = this.state;

    if (lat && lng) {
      const address = addresses.find((o) => o.id === selectedAddress.id);
      const form = this.formRef.current;
      const values = {};

      values[`lat${address.id}`] = lat;
      values[`lng${address.id}`] = lng;

      form.setFieldsValue(values);

      address.hasLocation = true;
    }

    this.hideMap();
  };

  handleAddAddress = () => {
    const { addresses } = this.state;

    if (addresses.length < 6) {
      addresses.push({ id: addresses.length });

      this.setState({ addresses: addresses });
    }
  };

  handleDelAddress = (ind) => {
    const { addresses } = this.state;
    const values = this.formRef.current.getFieldsValue();

    addresses.forEach((o) => {
      if (ind <= o.id) {
        values[`address${o.id}`] = values[`address${o.id + 1}`] || "";
        values[`lat${o.id}`] = values[`lat${o.id + 1}`] || "";
        values[`lng${o.id}`] = values[`lng${o.id + 1}`] || "";
      }
    });

    addresses.pop();

    this.formRef.current.setFieldsValue(values);

    this.setState({ addresses: addresses });
  };

  handleAddPhone = () => {
    const { phones } = this.state;

    if (phones.length < 5) {
      phones.push({ id: phones.length });

      this.setState({ phones: phones });
    }
  };

  handleDelPhone = (ind) => {
    const { phones } = this.state;
    const values = this.formRef.current.getFieldsValue();

    phones.forEach((o) => {
      if (ind <= o.id)
        values[`phone${o.id}`] = values[`phone${o.id + 1}`] || "";
    });

    phones.pop();

    this.formRef.current.setFieldsValue(values);

    this.setState({ phones: phones });
  };

  handleSubmit = () => {
  this.formRef.current
    .validateFields()
    .then((values) => {
      console.log(values);
      const { addresses, phones } = this.state;
      const { dataBirth } = values;

      console.log("addresses", addresses)
      const data = {
        phone: values.phone,
        name: values.name,
        family: values.family,
        level: values.level,
        address: [],
        lat: [],
        lng: [],
        city_id: values.city_id,
        neighborhood_id: values.neighborhood_id
      };

      if (dataBirth) {
        data.dataBirth = moment(
          `${dataBirth.year}-${dataBirth.month}-${dataBirth.day}`,
          Constants.jDateFormat
        ).format(Constants.dateFormat);
      }

      if (phones.length) {
        data.otherPhone = [data.phone];

        phones.forEach((o) => {
          data.otherPhone.push(values[`phone${o.id}`]);
        });
      }

      addresses.forEach((o) => {
        if(o.id){
           data.address.push(values[`address${o.id}`] || null);
          data.lat.push(values[`lat${o.id}`] || null);
          data.lng.push(values[`lng${o.id}`] || null);
        }
       
      });

      this.props.onSubmit(data);
    })
    .catch((errorInfo) => {
      console.log("Validation Failed:", errorInfo);
    });
};

  // handleSubmit = () => {
  //   this.formRef.current.validateFields().then((values) => {
  //     console.log(values)
  //     const { addresses, phones } = this.state;
  //     const { dataBirth } = values;
  //     const data = {
  //       phone: values.phone,
  //       name: values.name,
  //       family: values.family,
  //       level: values.level,
  //       address: [],
  //       lat: [],
  //       lng: [],
  //       city_id: values.city_id,
  //       neighborhood_id: values.neighborhood_id
  //     };

  //     if (dataBirth)
  //       data.dataBirth = moment(
  //         `${dataBirth.year}-${dataBirth.month}-${dataBirth.day}`,
  //         Constants.jDateFormat
  //       ).format(Constants.dateFormat);

  //     if (phones.length) {
  //       data.otherPhone = [data.phone];

  //       phones.forEach((o) => {
  //         data.otherPhone.push(values[`phone${o.id}`]);
  //       });
  //     }

  //     addresses.forEach((o) => {
  //       data.address.push(values[`address${o.id}`]);
  //       data.lat.push(values[`lat${o.id}`] || "");
  //       data.lng.push(values[`lng${o.id}`] || "");
  //     });

  //     this.props.onSubmit(data);
  //   });
  // };

  handleWillUnmount = () => {
    this.formRef.current.resetFields();

    this.setState({
      addresses: [{ id: 0 }],
      phones: [],
    });
  };

  handleDidMount = async(data = {}) => {
    const cloneData = cloneDeep(data);
    const phones = [];
    const addresses = [];

    await this.fetchCities(1)
    if(cloneData.city_id)
      await this.fetchNeighborhoods(cloneData.city_id)
    if (cloneData.phones && cloneData.phones.length) {
      cloneData.phones
        .filter((p) => p.phone !== cloneData.phone)
        .forEach((o, i) => {
          phones.push({ id: i });
          cloneData[`phone${i}`] = o.phone;
        });
    }

    if (cloneData.address && cloneData.address.length) {
      cloneData.address.forEach((o, i) => {
        addresses.push({ id: i, hasLocation: !!o.lat && !!o.lng });
        cloneData[`address${i}`] = o.address;
        cloneData[`lat${i}`] = o.lat;
        cloneData[`lng${i}`] = o.lng;
      });
    } else {
      addresses.push({ id: 0 });
    }

    if (cloneData.dataBirth) {
      const dataBirth = moment(cloneData.dataBirth);

      cloneData.dataBirth = {
        day: dataBirth.jDate(),
        month: dataBirth.jMonth() + 1,
        year: dataBirth.jYear(),
      };
    }

    this.formRef.current.setFieldsValue(cloneData);
    this.setState({
      editMode: !!cloneData.id,
      addresses: addresses,
      phones: phones,
    });
  };

    // -------------------------
    // Fetch Cities
    // -------------------------
    fetchCities = (countryId) => {
      if (!countryId) return;
  
  
      console.log("countryId", countryId)
      API.city
        .list( countryId )
        .then((res) => {
          this.setState({
            cities: res.data || [],
          });
        })
        .catch(() => {
        });
    };

    fetchNeighborhoods = (cityId) => {
      console.log(cityId)
      if (!cityId) return;

      API.neighborhood
        .list(cityId)
        .then((res) => {
          this.setState({
            neighborhoods: res.data || [],
          });
        })
        .catch(() => {});
    };


  render() {
    const { onCancel, submitting, visible } = this.props;
    const { addresses, editMode, phones, visibleMap, cities, neighborhoods } = this.state;

    const DatePickerInput = ({ ref }, name) => {
      const date = this.formRef.current
        ? this.formRef.current.getFieldValue(name)
        : null;
      return (
        <Input
          value={date ? `${date.year}-${date.month}-${date.day}` : date}
          prefix={<CalendarOutlined />}
          placeholder={Resources.choose}
          ref={ref}
          readOnly
        />
      );
    };

    return (
      <Fragment>
        <Modal
          title={editMode ? Resources.edit : Resources.add}
          visible={visible}
          onOk={this.handleSubmit}
          onCancel={onCancel}
          okText={Resources.confirm}
          cancelText={Resources.cancel}
          okButtonProps={{ loading: submitting }}
          cancelButtonProps={{ disabled: submitting }}
          className="modal-users"
          width={700}
        >
          <Form ref={this.formRef} layout="vertical">
            <Row gutter={24}>
              <Col xs={24} md={phones.length ? 12 : 24}>
                <Row gutter={6}>
                  <Col xs={20}>
                    <Form.Item
                      name="phone"
                      label={Resources.mobile}
                      rules={Rules.required}
                    >
                      <Input
                        type="text"
                        dir="ltr"
                        prefix={<MobileOutlined />}
                        placeholder={Resources.mobileHint}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={4}>
                    <Button onClick={this.handleAddPhone} block>
                      <PlusOutlined />
                    </Button>
                  </Col>
                </Row>
              </Col>
              {phones.map((o) => (
                <Col xs={24} md={12} key={o.id}>
                  <Row gutter={6}>
                    <Col xs={20}>
                      <Form.Item
                        name={`phone${o.id}`}
                        label={Resources.mobilePhone}
                        rules={Rules.required}
                      >
                        <Input
                          type="text"
                          dir="ltr"
                          prefix={<PhoneOutlined />}
                          placeholder={Resources.mobilePhoneHint}
                        />
                      </Form.Item>
                    </Col>
                    <Col xs={4}>
                      <Button onClick={() => this.handleDelPhone(o.id)} block>
                        <MinusOutlined />
                      </Button>
                    </Col>
                  </Row>
                </Col>
              ))}
            </Row>
            <Row gutter={24}>
              <Col xs={24} md={12}>
                <Form.Item name="name" label={Resources.firstName}>
                  <Input
                    type="text"
                    prefix={<UserOutlined />}
                    placeholder={Resources.nameHint}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="family"
                  label={Resources.lastName}
                  rules={Rules.required}
                >
                  <Input
                    type="text"
                    prefix={<UserOutlined />}
                    placeholder={Resources.nameHint}
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item name="dataBirth" label={Resources.birthdate}>
                  <DatePicker
                    locale="fa"
                    onChange={(value) =>
                      this.handleChangeDate(value, "dataBirth")
                    }
                    renderInput={(ref) => DatePickerInput(ref, "dataBirth")}
                    shouldHighlightWeekends
                  />
                </Form.Item>
              </Col>
              <Col xs={24} md={12}>
                <Form.Item
                  name="level"
                  label={Resources.permission}
                  rules={Rules.required}
                >
                  <Select placeholder={Resources.choose}>
                    <Select.Option value="admin">
                      {Resources.admin}
                    </Select.Option>
                    <Select.Option value="user">{Resources.user}</Select.Option>
                    <Select.Option value="operator">
                      {Resources.operator}
                    </Select.Option>
                  </Select>

                </Form.Item>
              </Col>


               <Col xs={24} md={12} >
                <Form.Item
                  name="city_id"
                  label={Resources.city}
                 


                >
                          <Select
                            placeholder="انتخاب شهر"
                            style={{ width: "100%" }}
                             onChange={(value) => this.fetchNeighborhoods(value)}
                              allowClear
                          >
                            {cities.map((item) => (
                              <Select.Option key={item.id} value={item.id}>
                                {item.name}
                              </Select.Option>
                            ))}
                          </Select>
                    </Form.Item>
                </Col>

                <Col xs={24} md={12}>
                  <Form.Item
                    name="neighborhood_id"
                    label="محله"
                  >
                    <Select
                      placeholder="انتخاب محله"
                      style={{ width: "100%" }}
                      allowClear
                    >
                      {neighborhoods.map((item) => (
                        <Select.Option key={item.id} value={item.id}>
                          {item.name}
                        </Select.Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

            </Row>

            
            <Row gutter={6}>
              {addresses.map((o) => (
                <Fragment key={o.id}>
                  <Col xs={20}>
                    <Form.Item
                      name={`address${o.id}`}
                      label={Resources.address}
                      // rules={Rules.required}
                    >
                      <Input
                        type="text"
                        prefix={<HomeOutlined />}
                        placeholder={Resources.addressHint}
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={4}>
                    {o.id === 0 && (
                      <Button
                        type="default"
                        onClick={() => this.handleAddAddress(o.id)}
                        block
                      >
                        <PlusOutlined />
                      </Button>
                    )}
                    {o.id > 0 && (
                      <Button
                        type="default"
                        onClick={() => this.handleDelAddress(o.id)}
                        block
                      >
                        <MinusOutlined />
                      </Button>
                    )}
                  </Col>
                  <Col xs={10}>
                    <Form.Item name={`lat${o.id}`}>
                      <Input
                        type="text"
                        placeholder={Resources.latitude}
                        disabled
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={10}>
                    <Form.Item name={`lng${o.id}`}>
                      <Input
                        type="text"
                        placeholder={Resources.longitude}
                        disabled
                      />
                    </Form.Item>
                  </Col>
                  <Col xs={4}>
                    <Button
                      type={o.hasLocation ? "primary" : "default"}
                      onClick={() => this.showMap(o)}
                      style={{ marginTop: 0 }}
                      block
                    >
                      <EnvironmentOutlined />
                    </Button>
                  </Col>
                </Fragment>
              ))}
            </Row>
          </Form>
        </Modal>
        <ModalMap
          ref={this.mapRef}
          onCancel={this.hideMap}
          onOk={this.handleLatLng}
          visible={visibleMap}
        />
      </Fragment>
    );
  }
}

export default UserForm;
